import { CastBetTypes } from "../../../types";
export const isCastBet = (betType) => {
    return betType in CastBetTypes;
};
//# sourceMappingURL=isCastBet.js.map